














import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/shared/components/Loading.vue';
import { ConfigService } from '@/shared/services/config.service';
import { DivisionModule } from '@/store';
import {
  FilterConditions,
  FilterInput,
  TransformFiltersToJson
} from '@/shared/services/filter/filter.service';
import { ToastHelper } from '@/utils/toast.util';
import { getLanguageCode } from '@/utils/utils';
import { i18n } from '@/i18n';

@Component({
  components: { Loading }
})
export default class GeofencePage extends Vue {
  // variables
  loading = true;
  isframe = false;
  frameUrl = null;

  idFilter = new FilterInput({
    condition: FilterConditions.BeginsWith,
    search: 'FMS_ACCT',
    field: 'id'
  });

  divFilter = new FilterInput({
    condition: FilterConditions.Equal,
    search: DivisionModule.division,
    field: 'div'
  });

  // constructor
  constructor() {
    super();
  }

  // methods
  created() {}

  mounted() {
    this.getConfig();
  }

  getConfig() {
    try {
      ConfigService.getConfig(
        TransformFiltersToJson([this.idFilter, this.divFilter])
      ).then(async result => {
        const data = {
          userId: result.data.find(a => a.id === 'FMS_ACCT_USERNAME')?.value,
          password: result.data.find(a => a.id === 'FMS_ACCT_PASSWORD')?.value
        };
        this.frameUrl =
          `${process.env.VUE_APP_FLEETUP_MAP_URL}/login_tms.html?key=${btoa(
            'userId=' + data.userId + '&' + 'password=' + data.password
          )}&to=admin.advancedMap.geofence&lang=` +
         getLanguageCode(i18n.locale);
        this.isframe = true;
      });
    } catch (error) {
      console.log(error);
      ToastHelper.show(
        `${this.$route.params.type}/${this.$route.name.replace(
          `${this.$route.params.type}-`,
          ''
        )}`,
        error.message,
        5000,
        'danger'
      );
    } finally {
      setTimeout(() => {
        this.loading = false;
      }, 10000);
    }
  }
}
